import {memo, PropsWithChildren, ReactNode} from "react";
import {useHistory} from "react-router-dom";
import {layoutMqValue} from "../box";
import {Chip} from "../chip";

import {Icon} from "../icon";
import {Skeleton} from "../skeleton";

import * as SC from "./index.styles";

interface TitleProps {
  title?: ReactNode;
  chip?: string;
  chipValue?: number;
  chipValueString?: string;
  chipType?: 'price';
  loading?: boolean;
  goBackLink?: string;
  breakpoint?: number | string;
  extend?: boolean;
  breakContent?: boolean;
}

export const TitleDash = SC.Dash;

export const Title = memo(function TitleComponent(
  props: PropsWithChildren<TitleProps> & Pick<JSX.IntrinsicElements["div"], "style" | "className">,
) {
  const {title, chip, goBackLink, loading, breakpoint = layoutMqValue, children, chipValueString, chipValue = null, chipType, ...rest} = props;

  const history = useHistory();

  let valueColor: undefined | boolean = undefined;
  if (chipType  === "price") {
    if (chipValue && chipValue > 0) {
      valueColor = true;
    } else if (chipValue && chipValue < 0) {
      valueColor = false
    }
  }

  return (
    <SC.Wrapper {...rest} bp={+breakpoint} hasArrow={!!goBackLink}>
      <SC.TitleWrapper>
        {goBackLink && (
          <SC.Icon>
            <Icon onClick={() => history.push(goBackLink)} icon="arrow" rotate={1} size="m" button color="c300" />
          </SC.Icon>
        )}
        <Skeleton width={180} height={40} variant="contrast" active={loading}>
          <SC.Title>{title}</SC.Title>
        </Skeleton>
        <SC.TitleMargin />
        {chip && (
          <Skeleton width={80} height={22} variant="contrast" active={loading}>
            <Chip variant="white" label={chip} value={chipValueString || chipValue} valueColor={valueColor} />
          </Skeleton>
        )}
      </SC.TitleWrapper>
      {children && <SC.Content>{children}</SC.Content>}
    </SC.Wrapper>
  );
});
